<tc-result-header
        [heading]="heading"
        [sorters]="sorters_"
        (selectSorter)="onSort($event)">
</tc-result-header>

<tc-adv-vehicle-search-results
        *ngIf="searchResults && searchResults.length>0"
        [sorters]="sorters_"
        [sortingHandler]="sorterService.method"
        [sorter]="sorterService.sorter"
        [pager]="pager"
        [vehiclesResultsList]="contentCardDataList"
        [selectedVehicleSummary]="selectedVehicleSummary"
        [selectedVehicleCost]="resourceCost"
        [detailedVehicle]="detailedResource"
        (resourceSelect)="onResourceSelect($event)"
        (calendarClick)="onCalendarClick($event)"
        (edit)="onEditResource($event)"
        (editAsNew)="onEditAsNewResource($event)"
        (cardScroll)="onCardScroll($event)">
</tc-adv-vehicle-search-results>

<tc-paginator
        *ngIf="contentCardDataList.length > defaultPageResultCount"
        [length]="contentCardDataList.length"
        [index]="pager.currPage"
        [size]="pager.itemsPerPage"
        [hasMore]="paginatorHasMore"
        (page)="onPage($event)"
        (more)="onMore()">
</tc-paginator>
